module.exports = __webpack_public_path__ + "assets/img/ic-reload-hover.01b50527.svg";